import { AxiosInstance, AxiosResponse } from 'axios';

export interface SimulationCubeFilters {
  company_entity_ids?: (string | number)[];
  counterparty_ids?: (string | number)[];
  currency_id?: string | number;
  trade_ids?: (string | number)[];
  start_date?: string;
}

export interface SimulationCubePayload {
  simulation_job_id: number;
  metadata: {
    num_simulations: number;
    num_trades: number;
    num_dates: number;
    num_currency_pairs: number;
    curve_date: string;
    currency_id: number;
    created_at: string;
  };
  trade_id_list: number[];
  simulation_data: Array<{
    date: string;
    simulations: number[][];
  }>;
  spot_rate_cube: Record<string, Record<string, number[]>>;
}

export interface SimulationCubeResponse {
  success: boolean;
  data: SimulationCubePayload;
  error_msg?: string;
}

export default class SimulationAPI {
  private client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async fetchCube(
    filters: SimulationCubeFilters,
  ): Promise<AxiosResponse<SimulationCubeResponse>> {
    const { start_date, ...filterParams } = filters;
    return this.client.post('/v2/simulation/cube/', {
      filters: filterParams,
      ...(start_date ? { start_date } : {}),
    });
  }
}
